import type { I18nKey } from 'types/i18n'

import * as nombresRuta from './nombres'
import { buildBreadcrumb } from '@/@core/utils/router'
import { permissionTree, RESOURCE_PRODUCCION_PG } from '@/auth/permissions/modules/produccionPg'
import { defineRoutes } from '@/utils/router'

//#region helpers
const breadcrumbMantenimiento = (option: I18nKey) =>
    buildBreadcrumb('a:produccion_pg.menu_title', 'a:global.menu.mantenimiento', option)
const breadcrumbTransaccion = (option: I18nKey) =>
    buildBreadcrumb('a:produccion_pg.menu_title', 'a:global.menu.transaccion', option)
const breadcrumbConfiguracion = (option: I18nKey) =>
    buildBreadcrumb('a:produccion_pg.menu_title', 'a:global.menu.configuracion', option)

// const breadcrumbDashboard = (option: I18nKey) =>
//     buildBreadcrumb('a:produccion_pg.menu_title', 'a:global.menu.dashboard', option)

// const breadcrumbInformes = (option: I18nKey) =>
//     buildBreadcrumb('a:produccion_pg.menu_title', 'a:global.menu.informes', option)
//#endregion

const { mantenimiento, configuracion, transacciones, informes } = permissionTree

export default defineRoutes([
    {
        path: '/v2/produccion-pg/mantenimiento/items/categoria',
        name: nombresRuta.ROUTE_PPG_CATEGORIA,
        component: () => import('@pages/v2/produccion-pg/mantenimiento/items/Categoria.vue'),
        meta: {
            title: 'i18n:produccion_pg.subopciones.categoria',
            action: mantenimiento.categoria,
            resource: RESOURCE_PRODUCCION_PG,
            breadcrumbs: breadcrumbMantenimiento('produccion_pg.subopciones.categoria'),
        },
    },
    {
        path: '/v2/produccion-pg/mantenimiento/items/tipo-producto',
        name: nombresRuta.ROUTE_PPG_TIPO_PRODUCTO,
        component: () => import('@pages/v2/produccion-pg/mantenimiento/items/TipoProducto.vue'),
        meta: {
            title: 'i18n:produccion_pg.subopciones.tipo_producto',
            action: mantenimiento.tipo_producto,
            resource: RESOURCE_PRODUCCION_PG,
            breadcrumbs: breadcrumbMantenimiento('produccion_pg.subopciones.tipo_producto'),
        },
    },
    {
        path: '/v2/produccion-pg/mantenimiento/items/linea-producto',
        name: nombresRuta.ROUTE_PPG_LINEA_PRODUCTO,
        component: () => import('@pages/v2/produccion-pg/mantenimiento/items/LineaProducto.vue'),
        meta: {
            title: 'i18n:produccion_pg.subopciones.linea_producto',
            action: mantenimiento.linea_producto,
            resource: RESOURCE_PRODUCCION_PG,
            breadcrumbs: breadcrumbMantenimiento('produccion_pg.subopciones.linea_producto'),
        },
    },
    {
        path: '/v2/produccion-pg/mantenimiento/items/subtipo-producto',
        name: nombresRuta.ROUTE_PPG_SUBTIPO_PRODUCTO,
        component: () => import('@/views/pages/v2/produccion-pg/mantenimiento/items/SubtipoProducto.vue'),
        meta: {
            title: 'i18n:produccion_pg.subopciones.subtipo_producto',
            action: mantenimiento.subtipo_producto,
            resource: RESOURCE_PRODUCCION_PG,
            breadcrumbs: breadcrumbMantenimiento('produccion_pg.subopciones.subtipo_producto'),
        },
    },
    {
        path: '/v2/produccion-pg/mantenimiento/items/especie',
        name: nombresRuta.ROUTE_PPG_ESPECIE,
        component: () => import('@pages/v2/produccion-pg/mantenimiento/items/Especie.vue'),
        meta: {
            title: 'i18n:produccion_pg.subopciones.especie',
            action: mantenimiento.especie,
            resource: RESOURCE_PRODUCCION_PG,
            breadcrumbs: breadcrumbMantenimiento('produccion_pg.subopciones.especie'),
        },
    },
    {
        path: '/v2/produccion-pg/mantenimiento/items/grupo_talla',
        name: nombresRuta.ROUTE_PPG_GRUPO_TALLA,
        component: () => import('@pages/v2/produccion-pg/mantenimiento/items/GrupoTalla.vue'),
        meta: {
            title: 'i18n:produccion_pg.subopciones.grupo_talla',
            action: mantenimiento.grupo_talla,
            resource: RESOURCE_PRODUCCION_PG,
            breadcrumbs: breadcrumbMantenimiento('produccion_pg.subopciones.grupo_talla'),
        },
    },
    {
        path: '/v2/produccion-pg/mantenimiento/items/tipo_talla',
        name: nombresRuta.ROUTE_PPG_TIPO_TALLA,
        component: () => import('@pages/v2/produccion-pg/mantenimiento/items/TipoTalla.vue'),
        meta: {
            title: 'i18n:produccion_pg.subopciones.tipo_talla',
            action: mantenimiento.tipo_talla,
            resource: RESOURCE_PRODUCCION_PG,
            breadcrumbs: breadcrumbMantenimiento('produccion_pg.subopciones.tipo_talla'),
        },
    },
    {
        path: '/v2/produccion-pg/mantenimiento/items/proceso',
        name: nombresRuta.ROUTE_PPG_PROCESO,
        component: () => import('@pages/v2/produccion-pg/mantenimiento/items/Proceso.vue'),
        meta: {
            title: 'i18n:produccion_pg.subopciones.proceso',
            action: mantenimiento.proceso,
            resource: RESOURCE_PRODUCCION_PG,
            breadcrumbs: breadcrumbMantenimiento('produccion_pg.subopciones.proceso'),
        },
    },
    {
        path: '/v2/produccion-pg/mantenimiento/items/calidad',
        name: nombresRuta.ROUTE_PPG_CALIDAD,
        component: () => import('@pages/v2/produccion-pg/mantenimiento/items/Calidad.vue'),
        meta: {
            title: 'i18n:produccion_pg.subopciones.calidad',
            action: mantenimiento.calidad,
            resource: RESOURCE_PRODUCCION_PG,
            breadcrumbs: breadcrumbMantenimiento('produccion_pg.subopciones.calidad'),
        },
    },
    {
        path: '/v2/produccion-pg/mantenimiento/items/subproceso',
        name: nombresRuta.ROUTE_PPG_SUBPROCESO,
        component: () => import('@pages/v2/produccion-pg/mantenimiento/items/SubProceso.vue'),
        meta: {
            title: 'i18n:produccion_pg.subopciones.subproceso',
            action: mantenimiento.subproceso,
            resource: RESOURCE_PRODUCCION_PG,
            breadcrumbs: breadcrumbMantenimiento('produccion_pg.subopciones.subproceso'),
        },
    },
    {
        path: '/v2/produccion-pg/mantenimiento/items/presentacion',
        name: nombresRuta.ROUTE_PPG_PRESENTACION,
        component: () => import('@pages/v2/produccion-pg/mantenimiento/items/Presentacion.vue'),
        meta: {
            title: 'i18n:produccion_pg.subopciones.presentacion',
            action: mantenimiento.presentacion,
            resource: RESOURCE_PRODUCCION_PG,
            breadcrumbs: breadcrumbMantenimiento('produccion_pg.subopciones.presentacion'),
        },
    },
    {
        path: '/v2/produccion-pg/mantenimiento/items/clasificacion',
        name: nombresRuta.ROUTE_PPG_CLASIFICACION,
        component: () => import('@pages/v2/produccion-pg/mantenimiento/items/Clasificacion.vue'),
        meta: {
            title: 'i18n:produccion_pg.subopciones.clasificacion',
            action: mantenimiento.clasificacion,
            resource: RESOURCE_PRODUCCION_PG,
            breadcrumbs: breadcrumbMantenimiento('produccion_pg.subopciones.clasificacion'),
        },
    },
    {
        path: '/v2/produccion-pg/mantenimiento/items/talla',
        name: nombresRuta.ROUTE_PPG_TALLA,
        component: () => import('@pages/v2/produccion-pg/mantenimiento/items/Talla.vue'),
        meta: {
            title: 'i18n:produccion_pg.subopciones.talla',
            action: mantenimiento.talla,
            resource: RESOURCE_PRODUCCION_PG,
            breadcrumbs: breadcrumbMantenimiento('produccion_pg.subopciones.talla'),
        },
    },
    {
        path: '/v2/produccion-pg/mantenimiento/items/producto',
        name: nombresRuta.ROUTE_PPG_PRODUCTO,
        component: () => import('@pages/v2/produccion-pg/mantenimiento/items/Producto.vue'),
        meta: {
            title: 'i18n:produccion_pg.subopciones.producto',
            action: mantenimiento.producto,
            resource: RESOURCE_PRODUCCION_PG,
            breadcrumbs: breadcrumbMantenimiento('produccion_pg.subopciones.producto'),
        },
    },
    {
        path: '/v2/produccion-pg/mantenimiento/items/marca',
        name: nombresRuta.ROUTE_PPG_MARCA,
        component: () => import('@pages/v2/produccion-pg/mantenimiento/items/Marca.vue'),
        meta: {
            title: 'i18n:produccion_pg.subopciones.marca',
            action: mantenimiento.marca,
            resource: RESOURCE_PRODUCCION_PG,
            breadcrumbs: breadcrumbMantenimiento('produccion_pg.subopciones.marca'),
        },
    },
    {
        path: '/v2/produccion-pg/mantenimiento/items/master',
        name: nombresRuta.ROUTE_PPG_MASTER,
        component: () => import('@pages/v2/produccion-pg/mantenimiento/items/Master.vue'),
        meta: {
            title: 'i18n:produccion_pg.subopciones.master',
            action: mantenimiento.master,
            resource: RESOURCE_PRODUCCION_PG,
            breadcrumbs: breadcrumbMantenimiento('produccion_pg.subopciones.master'),
        },
    },
    {
        path: '/v2/produccion-pg/mantenimiento/items/empaque',
        name: nombresRuta.ROUTE_PPG_EMPAQUE,
        component: () => import('@pages/v2/produccion-pg/mantenimiento/items/Empaque.vue'),
        meta: {
            title: 'i18n:produccion_pg.subopciones.empaque',
            action: mantenimiento.empaque,
            resource: RESOURCE_PRODUCCION_PG,
            breadcrumbs: breadcrumbMantenimiento('produccion_pg.subopciones.empaque'),
        },
    },
    {
        path: '/v2/produccion-pg/mantenimiento/items/congelacion',
        name: nombresRuta.ROUTE_PPG_CONGELACION,
        component: () => import('@pages/v2/produccion-pg/mantenimiento/items/Congelacion.vue'),
        meta: {
            title: 'i18n:produccion_pg.subopciones.congelacion',
            action: mantenimiento.congelacion,
            resource: RESOURCE_PRODUCCION_PG,
            breadcrumbs: breadcrumbMantenimiento('produccion_pg.subopciones.congelacion'),
        },
    },
    {
        path: '/v2/produccion-pg/mantenimiento/items/hidratacion',
        name: nombresRuta.ROUTE_PPG_HIDRATACION,
        component: () => import('@pages/v2/produccion-pg/mantenimiento/items/Hidratacion.vue'),
        meta: {
            title: 'i18n:produccion_pg.subopciones.hidratacion',
            action: mantenimiento.hidratacion,
            resource: RESOURCE_PRODUCCION_PG,
            breadcrumbs: breadcrumbMantenimiento('produccion_pg.subopciones.hidratacion'),
        },
    },
    {
        path: '/v2/produccion-pg/mantenimiento/items/condicion',
        name: nombresRuta.ROUTE_PPG_CONDICION,
        component: () => import('@pages/v2/produccion-pg/mantenimiento/items/Condicion.vue'),
        meta: {
            title: 'i18n:produccion_pg.subopciones.condicion',
            action: mantenimiento.condicion,
            resource: RESOURCE_PRODUCCION_PG,
            breadcrumbs: breadcrumbMantenimiento('produccion_pg.subopciones.condicion'),
        },
    },
    {
        path: '/v2/produccion-pg/mantenimiento/items/subcondicion',
        name: nombresRuta.ROUTE_PPG_SUBCONDICION,
        component: () => import('@pages/v2/produccion-pg/mantenimiento/items/SubCondicion.vue'),
        meta: {
            title: 'i18n:produccion_pg.subopciones.subcondicion',
            action: mantenimiento.subcondicion,
            resource: RESOURCE_PRODUCCION_PG,
            breadcrumbs: breadcrumbMantenimiento('produccion_pg.subopciones.subcondicion'),
        },
    },
    {
        path: '/v2/produccion-pg/mantenimiento/items/tratamiento',
        name: nombresRuta.ROUTE_PPG_TRATAMIENTO,
        component: () => import('@pages/v2/produccion-pg/mantenimiento/items/Tratamiento.vue'),
        meta: {
            title: 'i18n:produccion_pg.subopciones.tratamiento',
            action: mantenimiento.tratamiento,
            resource: RESOURCE_PRODUCCION_PG,
            breadcrumbs: breadcrumbMantenimiento('produccion_pg.subopciones.tratamiento'),
        },
    },
    {
        path: '/v2/produccion-pg/mantenimiento/items/certificacion',
        name: nombresRuta.ROUTE_PPG_CERTIFICACION,
        component: () => import('@pages/v2/produccion-pg/mantenimiento/items/Certificacion.vue'),
        meta: {
            title: 'i18n:produccion_pg.subopciones.certificacion',
            action: mantenimiento.certificacion,
            resource: RESOURCE_PRODUCCION_PG,
            breadcrumbs: breadcrumbMantenimiento('produccion_pg.subopciones.certificacion'),
        },
    },
    // rutas configuraciones
    {
        path: '/v2/produccion-pg/configuracion/items/producto_base',
        name: nombresRuta.ROUTE_PPG_PRODUCTOBASE,
        component: () => import('@pages/v2/produccion-pg/configuracion/items/ProductoBase.vue'),
        meta: {
            title: 'i18n:produccion_pg.subopciones.producto_base',
            action: configuracion.producto_base,
            resource: RESOURCE_PRODUCCION_PG,
            breadcrumbs: breadcrumbConfiguracion('produccion_pg.subopciones.producto_base'),
        },
    },
    {
        path: '/v2/produccion-pg/configuracion/items/nivel_aprobacion_producto',
        name: nombresRuta.ROUTE_PPG_NIVELAPROBACIONPRODUCTO,
        component: () => import('@pages/v2/produccion-pg/configuracion/items/NivelAprobacionProducto.vue'),
        meta: {
            title: 'i18n:produccion_pg.subopciones.nivel_aprobacion_producto',
            action: configuracion.nivel_aprobacion_producto,
            resource: RESOURCE_PRODUCCION_PG,
            breadcrumbs: breadcrumbConfiguracion('produccion_pg.subopciones.nivel_aprobacion_producto'),
        },
    },
    {
        path: '/v2/produccion-pg/configuracion/items/nivel_aprobacion_op',
        name: nombresRuta.ROUTE_PPG_NIVELAPROBACIONOP,
        component: () => import('@pages/v2/produccion-pg/configuracion/items/NivelAprobacionOp.vue'),
        meta: {
            title: 'i18n:produccion_pg.subopciones.nivel_aprobacion_op',
            action: configuracion.nivel_aprobacion_op,
            resource: RESOURCE_PRODUCCION_PG,
            breadcrumbs: breadcrumbConfiguracion('produccion_pg.subopciones.nivel_aprobacion_op'),
        },
    },
    {
        path: '/v2/produccion-pg/configuracion/alerta_correo',
        name: nombresRuta.ROUTE_PPG_ALERTACORREO,
        component: () => import('@pages/v2/produccion-pg/configuracion/AlertaCorreo.vue'),
        meta: {
            title: 'i18n:produccion_pg.subopciones.alerta_correo',
            action: configuracion.alerta_correo,
            resource: RESOURCE_PRODUCCION_PG,
            breadcrumbs: breadcrumbConfiguracion('produccion_pg.subopciones.alerta_correo'),
        },
    },
    {
        path: '/v2/produccion-pg/configuracion/costo_proceso',
        name: nombresRuta.ROUTE_PPG_COSTOPROCESO,
        component: () => import('@pages/v2/produccion-pg/configuracion/CostoProceso.vue'),
        meta: {
            title: 'i18n:produccion_pg.subopciones.costo_proceso',
            action: configuracion.costo_proceso,
            resource: RESOURCE_PRODUCCION_PG,
            breadcrumbs: breadcrumbConfiguracion('produccion_pg.subopciones.costo_proceso'),
        },
    },
    // rutas transacciones
    {
        path: '/v2/produccion-pg/transaccion/items/orden_pedido',
        name: nombresRuta.ROUTE_PPG_ORDENPEDIDO,
        component: () => import('@pages/v2/produccion-pg/transaccion/items/OrdenPedido.vue'),
        meta: {
            title: 'i18n:produccion_pg.subopciones.orden_pedido',
            action: transacciones.orden_pedido,
            resource: RESOURCE_PRODUCCION_PG,
            breadcrumbs: breadcrumbTransaccion('produccion_pg.subopciones.orden_pedido'),
        },
    },
    {
        path: '/v2/produccion-pg/transaccion/items/orden_trabajo/:id_orden_trabajo?',
        name: nombresRuta.ROUTE_PPG_ORDENTRABAJO,
        component: () => import('@pages/v2/produccion-pg/transaccion/items/OrdenTrabajo.vue'),
        meta: {
            title: 'i18n:produccion_pg.subopciones.orden_trabajo',
            action: transacciones.orden_trabajo,
            resource: RESOURCE_PRODUCCION_PG,
            breadcrumbs: breadcrumbTransaccion('produccion_pg.subopciones.orden_trabajo'),
        },
    },
    {
        path: '/v2/produccion-pg/transaccion/items/bandeja_orden_trabajo',
        name: nombresRuta.ROUTE_PPG_BANDEJAORDENTRABAJO,
        component: () => import('@pages/v2/produccion-pg/transaccion/items/BandejaOrdenesTrabajo.vue'),
        meta: {
            title: 'i18n:produccion_pg.subopciones.gestion_orden_trabajo',
            action: transacciones.bandeja_orden_trabajo,
            resource: RESOURCE_PRODUCCION_PG,
            breadcrumbs: breadcrumbTransaccion('produccion_pg.subopciones.gestion_orden_trabajo'),
        },
    },
    {
        path: '/v2/produccion-pg/transaccion/items/aprobacion_producto',
        name: nombresRuta.ROUTE_PPG_APROBACIONPRODUCTO,
        component: () => import('@pages/v2/produccion-pg/transaccion/items/AprobacionProducto.vue'),
        meta: {
            title: 'i18n:produccion_pg.subopciones.aprobacion_producto',
            action: transacciones.aprobacion_producto,
            resource: RESOURCE_PRODUCCION_PG,
            breadcrumbs: breadcrumbTransaccion('produccion_pg.subopciones.aprobacion_producto'),
        },
    },
    {
        path: '/v2/produccion-pg/transaccion/items/aprobacion_op',
        name: nombresRuta.ROUTE_PPG_APROBACIONOP,
        component: () => import('@pages/v2/produccion-pg/transaccion/items/AprobacionOp.vue'),
        meta: {
            title: 'i18n:produccion_pg.subopciones.aprobacion_op',
            action: transacciones.aprobacion_op,
            resource: RESOURCE_PRODUCCION_PG,
            breadcrumbs: breadcrumbTransaccion('produccion_pg.subopciones.aprobacion_op'),
        },
    },
    {
        path: '/v2/produccion-pg/transacciones/orden-pedido/solicitud-cambio-op',
        name: nombresRuta.ROUTE_PPG_SOLICITUDCAMBIOOP,
        component: () => import('@/views/pages/v2/produccion-pg/transacciones/orden-pedido/SolicitudCambioOp.vue'),
        meta: {
            title: 'i18n:produccion_pg.subopciones.solicitud_cambio_op',
            action: transacciones.solicitud_cambio_op,
            resource: RESOURCE_PRODUCCION_PG,
            breadcrumbs: breadcrumbTransaccion('produccion_pg.subopciones.solicitud_cambio_op'),
        },
    },
    {
        path: '/v2/produccion-pg/transaccion/items/aprobacion_op_sin_anticipo',
        name: nombresRuta.ROUTE_PPG_APROBACIONOPSINANTICIPO,
        component: () => import('@pages/v2/produccion-pg/transaccion/items/AprobacionOpSinAnticipo.vue'),
        meta: {
            title: 'i18n:produccion_pg.subopciones.aprobacion_op_sin_anticipo',
            action: transacciones.aprobacion_op_sin_anticipo,
            resource: RESOURCE_PRODUCCION_PG,
            breadcrumbs: breadcrumbTransaccion('produccion_pg.subopciones.aprobacion_op_sin_anticipo'),
        },
    },
    // rutas informes
    {
        path: '/v2/produccion-pg/informes/consulta-orden-pedido',
        name: nombresRuta.ROUTE_PPG_CONSULTA_ORDEN_PEDIDO,
        component: () => import('@pages/v2/produccion-pg/informe/items/ConsultaOrdenPedido.vue'),
        meta: {
            title: 'i18n:produccion_pg.subopciones.consulta_orden_pedido',
            action: informes.consulta_orden_pedido,
            resource: RESOURCE_PRODUCCION_PG,
            breadcrumbs: breadcrumbTransaccion('produccion_pg.subopciones.consulta_orden_pedido'),
        },
    },
    {
        path: '/v2/produccion-pg/informes/bandeja-entrada_proformas',
        name: nombresRuta.ROUTE_PPG_BANDEJA_ENTRADA_PROFORMAS,
        component: () => import('@pages/v2/produccion-pg/informes/BandejaEntradaProformas.vue'),
        meta: {
            title: 'i18n:produccion_pg.subopciones.bandeja_entrada_proformas',
            action: informes.bandeja_entrada_proformas,
            resource: RESOURCE_PRODUCCION_PG,
            breadcrumbs: breadcrumbTransaccion('produccion_pg.subopciones.bandeja_entrada_proformas'),
        },
    },
])
